import linkModal from './link-modal';
export default linkModal;
